export default __webpack_public_path__ + "da946ba.png";